module.exports = __webpack_public_path__ + "static/img/car_free.9.b9068446.png";